import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Divider,
  Drawer,
  FormControl,
  IconButton,
  Input,
  InputLabel,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import useGetMatchingInternalProducts from '../../hooks/products/useMatchingInternalProducts';

const StockVerificationDrawer = ({ open, onClose }) => {
  const [searchIndex, setSearchIndex] = useState('');
  const [matchingProducts, setMatchingProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { getMatchingProducts } = useGetMatchingInternalProducts();

  useEffect(() => {
    if (open) {
      setMatchingProducts([]);
      setSearchIndex('');
    }
  }, [open]);

  const handleSearch = async () => {
    try {
      if (searchIndex?.length === 0) {
        return;
      } else {
        setIsLoading(true);
        const response = await getMatchingProducts(searchIndex);
        setMatchingProducts(response);
      }
    } catch (error) {
      console.error('Search failed:', error);
      setMatchingProducts([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter' && event.target.value.trim() !== '') {
      handleSearch();
    }
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiDrawer-paper': {
          width: '50%',
        },
      }}
    >
      <Box sx={{ width: '100%' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'start',
            alignItems: 'center',
            alignContent: 'center',
            padding: '8px',
          }}
        >
          <IconButton onClick={onClose} sx={{ marginRight: '16px' }}>
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" component="div">
            Vérification des stocks
          </Typography>
        </Box>
        <Divider />
        <Box sx={{ padding: '8px' }}>
          <FormControl
            variant="standard"
            sx={{
              width: '100%',
              marginBottom: '16px',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-end',
            }}
          >
            <InputLabel htmlFor="input-with-icon-adornment">
              Rechercher une pièce par référence Ex: &quot;PCS-000416&quot; ou
              par titre: &quot;SR-A4a&quot;
            </InputLabel>
            <Input
              value={searchIndex}
              onChange={(e) => setSearchIndex(e.target.value)}
              sx={{ width: '60%' }}
              id="input-with-icon-adornment"
              startAdornment={<></>}
              onKeyDown={handleKeyPress}
            />
            <Button
              startIcon={<SearchIcon />}
              size="small"
              sx={{ marginLeft: '16px' }}
              variant="contained"
              color="primary"
              onClick={handleSearch}
            >
              Rechercher
            </Button>
          </FormControl>
        </Box>
        <Box sx={{ padding: '16px', height: '100%' }}>
          <TableContainer component={Paper}>
            <Table sx={{ width: '100%' }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Référence</TableCell>
                  <TableCell>Titre</TableCell>
                  <TableCell>Couleur</TableCell>
                  <TableCell>Emballage</TableCell>
                  <TableCell align="right">Stock</TableCell>
                  <TableCell align="right">Enca</TableCell>
                  <TableCell align="right">Enco</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading ? (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      <CircularProgress
                        sx={{
                          marginRight: '8px',
                          width: '16px !important',
                          height: '16px !important',
                          verticalAlign: 'text-bottom',
                        }}
                      />
                      <span>Chargement des données...</span>
                    </TableCell>
                  </TableRow>
                ) : matchingProducts.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      Aucun résultat
                    </TableCell>
                  </TableRow>
                ) : (
                  matchingProducts?.map((product) => (
                    <TableRow
                      key={product.reference}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {product.reference}
                      </TableCell>
                      <TableCell>{product.title}</TableCell>
                      <TableCell>{product.color}</TableCell>
                      <TableCell>{product.packaging}</TableCell>
                      <TableCell align="right">
                        <Chip
                          label={product?.stock?.quantity || 'N/A'}
                          color={
                            product?.stock?.quantity > 0 ? 'success' : 'default'
                          }
                        />
                      </TableCell>
                      <TableCell align="right">
                        <Chip
                          label={
                            typeof product?.stock?.quantity_enca === 'number'
                              ? product?.stock?.quantity_enca
                              : 'N/A'
                          }
                          color={
                            product?.stock?.quantity_enca > 0
                              ? 'primary'
                              : 'default'
                          }
                        />
                      </TableCell>
                      <TableCell align="right">
                        <Chip
                          label={
                            typeof product?.stock?.quantity_enco === 'number'
                              ? product?.stock?.quantity_enco
                              : 'N/A'
                          }
                          color={
                            product?.stock?.quantity_enco > 0
                              ? 'warning'
                              : 'default'
                          }
                        />
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </Drawer>
  );
};

export default StockVerificationDrawer;
